import type { SVGProps } from 'react';

function BuildingIcon({ width = 60, height = 60, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox="0 0 100 100" preserveAspectRatio="none" {...props}>
      <rect x="10" y="35" width="80" height="58" fill="#c9b28a" stroke="#2f2f2f" strokeWidth="3" />
      <path
        d="M5 38 L50 8 L95 38 Z"
        fill="#a15c4a"
        stroke="#2f2f2f"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <rect x="43" y="63" width="14" height="30" fill="#5a3d2b" stroke="#2f2f2f" strokeWidth="2" />
      <rect x="20" y="48" width="14" height="14" fill="#bcdcec" stroke="#2f2f2f" strokeWidth="2" />
      <rect x="66" y="48" width="14" height="14" fill="#bcdcec" stroke="#2f2f2f" strokeWidth="2" />
    </svg>
  );
}

export default BuildingIcon;
